import { useCallback } from 'react';
import type { SetURLSearchParams } from 'react-router';
import { createSearchParams, useSearchParams } from 'react-router';

import { withoutLoadedPage } from '@jane/bloom/utils/queryParams/loadedPage';

/**
 * `useSearchParams` for filter and sort changes. A new set of criteria is a new
 * result set, so the persisted page count from the previous one is dropped.
 */
export const useFilterSearchParams = (): ReturnType<typeof useSearchParams> => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setFilterSearchParams = useCallback<SetURLSearchParams>(
    (nextInit, navigateOpts) =>
      setSearchParams(
        (prev) =>
          withoutLoadedPage(
            createSearchParams(
              typeof nextInit === 'function' ? nextInit(prev) : nextInit
            )
          ),
        navigateOpts
      ),
    [setSearchParams]
  );

  return [searchParams, setFilterSearchParams];
};
